import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { footer } from '../copy';

export interface PayerConnectionsFooterProps {
  liveCount: number;
  unknownCount?: number;
  /** Right-aligned slot (e.g. "Add a payer") — left to the wiring slice. */
  rightSlot?: ReactNode;
}

/** AC-4: the payer table's footer — live count, or "No payers live yet". */
export function PayerConnectionsFooter({
  liveCount,
  rightSlot,
  unknownCount = 0,
}: PayerConnectionsFooterProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '18px',
        py: 1.5,
        backgroundColor: 'grey.50',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography sx={{ fontSize: '12.5px', color: 'text.secondary' }}>
        {footer(liveCount, unknownCount)}
      </Typography>
      {rightSlot}
    </Box>
  );
}
